<template>
  <div id="app">
    <whin-navbar></whin-navbar>
    <div class="content-wrap">
      <router-view/>
    </div>
    <whin-footer></whin-footer>
  </div>
</template>

<script>

// Load font faces
import "@/assets/fonts/stylesheet.css";

import WhinNavbar from "@/components/Navbar";
import WhinFooter from "@/components/LegacyFooter";
export default {
  components: {WhinFooter, WhinNavbar}
}
</script>

<style lang="scss">
@import "assets/fonts/stylesheet.css";

/* Override bootstrap defaults here */
@import "assets/css/_custom.scss";

/* Import Bootstrap and BootstrapVue source SCSS files */
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.content-wrap {
  padding-top: 4rem;
}

.btn,a.btn,button {
  line-height: 1.5rem;
  border-radius: 5px;
  padding: 1rem 2rem;
  min-width: 10rem;
  text-transform: uppercase;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1.2rem;
}
@media (min-width: 992px) {
  .btn,a.btn,button {
    font-size: 1.4rem;
  }
}
</style>
